<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12" class="d-flex justify-center align-center"> </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="d-flex justify-center align-center">
        <v-img max-width="300" src="../assets/asclogo.png"></v-img>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="d-flex justify-center align-center">
        <h2>ระบบข้อมูลผู้เชี่ยวชาญด้านบริการวิชาการ</h2>
      </v-col>
      <v-col cols="12" class="d-flex justify-center align-center">
        <h3>กรุณากรอกข้อมูลเพื่อเข้าสู่ระบบ</h3>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="d-flex justify-center align-center">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            class="centered-input"
            label="รหัสบุคลากร"
            placeholder="ระบุเป็นตัวเลขติดกัน"
            outlined
            v-model="user.id"
            :counter="7"
            :rules="idRule"
            type="number"
          ></v-text-field>
          <v-text-field
            class="centered-input input-group--focused"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show ? 'text' : 'password'"
            name="input-10-2"
            outlined
            v-model="user.pass"
            label="รหัสผ่าน"
            placeholder="เหมือนระบบอินทราเน็ต"
            @click:append="show = !show"
          ></v-text-field>
          <div class="d-flex justify-center align-center">
            <v-btn :disabled="!valid" color="primary" @click="signIn">
              เข้าสู่ระบบ
            </v-btn>
          </div>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { GlobalFunction } from "./functions";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";

export default {
  mixins: [GlobalFunction],
  data: () => ({
    user: {},
    snackbar: false,
    valid: true,
    show: false,

    idRule: [
      (v) => !!v || "กรุณาระบุรหัสบุคลากร",
      (v) => (v && v.length == 7) || "รหัสบุคลากรมี 7 ตำแหน่ง",
    ],
    passRule: [(v) => !!v || "กรุณาระบุรหัสผ่าน"],
  }),

  methods: {
    signIn() {
      if (this.$refs.form.validate()) {
        console.log("Sign In");
      }
    },

    googleSignIn() {
      const auth = getAuth();
      const provider = new GoogleAuthProvider();
      signInWithPopup(auth, provider)
        .then((result) => {
          // This gives you a Google Access Token. You can use it to access the Google API.
          // console.log(result);
          // const credential = GoogleAuthProvider.credentialFromResult(result);
          // console.log(credential);
          this.checkHospital(result.user);
        })
        .catch((error) => {
          // Handle Errors here.
          console.log(error);
          // The AuthCredential type that was used.
          const credential = GoogleAuthProvider.credentialFromError(error);
          console.log(credential);
          // ...
        });
    },

    // async checkHospital(user) {
    //   // console.log(user.email);

    //   const q = query(
    //     collection(this.db, "hospitaluser"),
    //     where("email", "==", user.email)
    //   );
    //   const querySnapshot = await getDocs(q);

    //   // console.log(querySnapshot);

    //   if (querySnapshot.empty) {
    //     this.SignOut();
    //     // console.log("Not Admin.");
    //     this.snackbar = true;
    //   } else {
    //     // console.log("Admin");

    //     store.user = user;
    //     // console.log(store.user);
    //     localStorage.user = JSON.stringify(store.user);
    //     localStorage.token = JSON.stringify(store.token);

    //     this.$router.push({ path: "/checkprivilege" });
    //   }
    // },
  },
  watch: {},
  computed: {},
  mounted() {},
};
</script>

<style>
.pointer {
  cursor: pointer;
}
.centered-input.v-text-field .v-label {
  left: 50% !important;
  transform: translateX(-50%);
  transform-origin: top 50%;
}
.centered-input.v-text-field .v-label--active {
  left: 0% !important;
  transform: translateY(-25px) scale(0.75) translateX(0px);
}
/* @import "https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0-beta/css/materialize.min.css"; */
</style>
